import axios from 'axios'

import { BASE_URL } from '@/api/api.constants'
import { BoughtTogetherItemsResponseModel } from '@/types/clarityLens/response/salesLens'

export const getBoughtTogetherItems = async (
  branchName: string,
  startDate: string,
  endDate: string,
  itemGroupName: string,
  sizeFilter: string,
  temperatureFilter: string
): Promise<BoughtTogetherItemsResponseModel> => {
  try {
    const response = await axios.get(
      `${BASE_URL}/daily-sales-lens/bought-together`,
      {
        params: {
          start_date: startDate,
          end_date: endDate,
          branch_names: branchName,
          item_group_name: itemGroupName,
          ...(sizeFilter !== 'all' && {
            size: sizeFilter.charAt(0).toUpperCase() + sizeFilter.slice(1),
          }),
          ...(temperatureFilter !== 'all' && {
            style:
              temperatureFilter.charAt(0).toUpperCase() +
              temperatureFilter.slice(1),
          }),
          limit: 1000,
        },
      }
    )

    return response.data
  } catch (error) {
    throw error
  }
}
